import { Input as HeroInput, type InputProps as HeroInputProps } from '@heroui/react';
import { cn } from '@/lib/utils';

export type InputProps = HeroInputProps & { isDisabled?: boolean };

export function Input({ className, disabled, isDisabled, ...props }: InputProps) {
  return (
    <HeroInput
      className={cn(
        'h-10 w-full rounded-xl border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground shadow-none transition-colors focus:border-brand-500 focus:outline-none',
        className,
      )}
      disabled={disabled ?? isDisabled}
      {...props}
    />
  );
}
